module.exports = __webpack_public_path__ + "img/product-one-0.c2e92990.png";